exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.duplicate{width:400px\n}\n.duplicate .button{display:inline-block\n}\n.duplicate [type=number]{display:inline-block;margin:0 15px 0 0;width:60px\n}\n.save-container button{background-color:#298fe0;float:right\n}\n.save-container.save-top button{margin-top:-70px\n}\n.category__prices .room-select.room{width:200px\n}\np.error{color:red\n}", ""]);

// exports
